import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import SkillCard, {SkillColumnProps} from "../utils/SkillCard";


const frontendSkills: SkillColumnProps = {
  title: "Front-End",
  skillSet: [
    {
      name: 'Javascript',
      rate: 90
    },
    {
      name: 'React',
      rate: 80
    },
    {
      name: 'Redux',
      rate: 80
    },
    {
      name: "HTML",
      rate: 80
    },
    {
      name: "CSS/SCSS",
      rate: 60
    }
  ]
}

const backendSkills: SkillColumnProps = {
  title: "Back-End",
  skillSet: [
    {
      name: 'Java',
      rate: 80
    },
    {
      name: 'Spring & Spring Boot',
      rate: 80
    },
    {
      name: 'Hibernate',
      rate: 80
    },
    {
      name: "SQL",
      rate: 80
    },
    {
      name: "MongoDB",
      rate: 50
    },
    {
      name: "Microservices",
      rate: 60
    },
    {
      name: "Python",
      rate: 60
    }
  ]
}

const otherSkills: SkillColumnProps = {
  title: "Other skills",
  skillSet: [
    {
      name: 'Git',
      rate: 80
    },
    {
      name: "AWS Cloud",
      rate: 70
    },
    {
      name: "Agile-Scrum",
      rate: 70
    },
    {
      name: "Jira",
      rate: 70
    },
    {
      name: "Unit Test",
      rate: 70
    }

  ]
}
const SkillSet = () => {
  return (
    <div className="grad" style={{padding: "30px 25px", minHeight: '200px'}}>
      <Row style={{display: 'flex'}}>
        <h2>
          Programming Skills
        </h2>
      </Row>
      <Row>
        <Col sm={12} md={4}>
          <SkillCard skills={frontendSkills}/>
        </Col>
        <Col sm={12} md={4}>
          <SkillCard skills={backendSkills}/>
        </Col>
        <Col sm={12} md={4}>
          <SkillCard skills={otherSkills}/>
        </Col>
      </Row>
    </div>
  )
}

export default SkillSet;